/* tslint:disable */
import {
  Project
} from '../index';

declare var Object: any;
export interface ProjectFunderInterface {
  "name": string;
  "amount": number;
  "id"?: number;
  "projectId"?: number;
  "projectIdAdditionalFunder"?: number;
  project?: Project;
  projectAdditional?: Project;
}

export class ProjectFunder implements ProjectFunderInterface {
  "name": string;
  "amount": number;
  "id": number;
  "projectId": number;
  "projectIdAdditionalFunder": number;
  project: Project;
  projectAdditional: Project;
  constructor(data?: ProjectFunderInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProjectFunder`.
   */
  public static getModelName() {
    return "ProjectFunder";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ProjectFunder for dynamic purposes.
  **/
  public static factory(data: ProjectFunderInterface): ProjectFunder{
    return new ProjectFunder(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ProjectFunder',
      plural: 'ProjectFunders',
      path: 'ProjectFunders',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "amount": {
          name: 'amount',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "projectId": {
          name: 'projectId',
          type: 'number'
        },
        "projectIdAdditionalFunder": {
          name: 'projectIdAdditionalFunder',
          type: 'number'
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project'
        },
        projectAdditional: {
          name: 'projectAdditional',
          type: 'Project',
          model: 'Project'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/ProjectFunder.ts